
import { useState } from "react";
import { toast } from "react-toastify";
export function discountValidate (_value)    
    {
         var disdecimal ="^([0-9]{0,2}((.)[0-9]{0,2}))$";
         
          
            if( parseFloat(_value)>100)
            {
                toast.error("Please enter  discount less than 100%.");
                return false
            } 
               var varray= _value.split(".")
            if(varray.length==2 )
            {
               var _decvalue= parseFloat(varray[1]??0);

                if( _decvalue>100)
                {
                    toast.error("Please enter discount with two decimal point");
                    return false
                } 
            }

          
         return true;
    }
 
    

    export function decimalValueValidate (e)    
    {
         var disdecimal ="^([0-9]{0,4}((.)[0-9]{0,4}))$";
         var _value=e.target.value+e.key;
          
         if(_value!="")
         {
         if(_value.match(disdecimal))
            {
            var varray= _value.split(".")
            if(varray.length==4 )
            {
               var _decvalue= parseFloat(varray[1]??0);

                if( _decvalue>100)
                {
                    toast.error("Please enter value with two decimal point");
                    e.target.value=""
                } 
            }
            }else
            {
               toast.error("Please enter proper value");
                    e.target.value=""
                  
            }
         }
          
         return true;
    }


    export function decimalValidate (e)    
    {
         var disdecimal ="^([0-9]{0,2}((.)[0-9]{0,2}))$";
         var _value=e.target.value;
         console.log("aa",_value)
         if(_value!="")
         {
         if(_value.match(disdecimal))
            {
            var varray= _value.split(".")
            if(varray.length==2 )
            {
               var _decvalue= parseFloat(varray[1]??0);

                if( _decvalue>100)
                {
                    toast.error("Please enter value with two decimal point");
                    e.target.value=""
                } 
            }
            }else
            {
               toast.error("Please enter proper value");
                    e.target.value=""
            }
         }
          
         return true;
    }


    
    export function decimalQtyValidate (e)    
    {
         var disdecimal ="^([0-9]{0,2}((.)[0-9]{0,2}))$";
         var _value=e.target.value;
         if(_value!="")
         {
            if(_value.match(disdecimal))
            {   
               var varray= _value.split(".")
               if(varray.length==2 )
               {
                  var _decvalue= parseFloat(varray[1]??0);

                  if( _decvalue>100)
                  {
                     toast.error("Please enter value with two decimal point");
                     e.target.value=""
                  } 
               }else
               {
                  console.log("Txd")
               }
            }   
        }

          
         return true;
    }

    export function dateConversion (_value,sDateFormat,dDateFormat)    
    {

      //console.log("_value",_value)
      //console.log("sDateFormat",sDateFormat)
      //console.log("dDateFormat",dDateFormat)

        if(_value!="")
        {
             var _mm="";
             var _dd="";
             var _yyyy="";

             var _s0="";
             var _s1="";
             var _s2="";


             if( _value.includes("/"))
             {
                var dateSplit= _value.split("/")
                if(dateSplit.length==3)
                {
                _s0=dateSplit[0];
                _s1=dateSplit[1];
                _s2=dateSplit[2];
                }
             }

             if( _value.includes("-"))
             {
               
                var dateSplit= _value.split("-")
                if(dateSplit.length==3)
                {
                _s0=dateSplit[0];
                _s1=dateSplit[1];
                _s2=dateSplit[2];
                }
             }
             if( sDateFormat=="DD/MM/YYYY" || sDateFormat=="DD-MM-YYYY"||sDateFormat=="dd/MM/yyyy" || sDateFormat=="dd-MM-yyyy")
             {
                _dd=_s0;
                _mm= _s1;
                _yyyy=_s2
             }

             if( sDateFormat=="YYYY/MM/DD" || sDateFormat=="YYYY-MM-DD")
             {
  
                _dd=_s2;
                _mm= _s1;
                _yyyy=_s0;
             }


             if( dDateFormat=="DD/MM/YYYY")
             {


                var dDate=_dd+"/"+_mm+"/" +_yyyy

                
                return(dDate)
             }

             if( dDateFormat=="DD-MM-YYYY")
             {
                var dDate=_dd+"-"+_mm+"-" +_yyyy
                return(dDate)
             }
             if( dDateFormat=="YYYY/MM/DD")
             {
                var dDate=_yyyy +"/"+_mm+"/" +_dd
                return(dDate)
             }

             if( dDateFormat=="YYYY-MM-DD")
             {
                var dDate=_yyyy +"-"+_mm+"-" +_dd
                return(dDate)
             }
 
             
        }
        return(_value)
    }